module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table9E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 2-1：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 2-1：电子出版物出版情况登记表")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("年份：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.year),
      callback: function($$v) {
        _vm.$set(_vm.params, "year", $$v)
      },
      expression: "params.year"
    }
  }, _vm._l((_vm.yearOpts), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationName", $$v)
      },
      expression: "params.publicationName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专用书号（ISBN 978-7-）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.isbn),
      callback: function($$v) {
        _vm.$set(_vm.params, "isbn", $$v)
      },
      expression: "params.isbn"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("载体形式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [(_vm.pressType == 1) ? _c('div', {
    staticClass: "areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "carrierForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择载体形式"
    },
    model: {
      value: (_vm.params.carrierForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierForm", $$v)
      },
      expression: "params.carrierForm"
    }
  }, _vm._l((_vm.dicDats['C010']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.mediaTyp1[_vm.params.carrierForm] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "carrierFormQT",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.carrierFormQT),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierFormQT", $$v)
      },
      expression: "params.carrierFormQT"
    }
  })], 1) : _vm._e()], 1) : (_vm.pressType == 2) ? _c('div', {
    staticClass: "areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "carrierForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择载体形式"
    },
    model: {
      value: (_vm.params.carrierForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierForm", $$v)
      },
      expression: "params.carrierForm"
    }
  }, _vm._l((_vm.dicDats['C025']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.mediaTyp2[_vm.params.carrierForm] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "carrierFormQT",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.carrierFormQT),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierFormQT", $$v)
      },
      expression: "params.carrierFormQT"
    }
  })], 1) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版形式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.publicationForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationForm", $$v)
      },
      expression: "params.publicationForm"
    }
  }, _vm._l((_vm.dicDats['C011']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("节目来源/制作单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.productionUnit),
      callback: function($$v) {
        _vm.$set(_vm.params, "productionUnit", $$v)
      },
      expression: "params.productionUnit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("节目时长或容量(分钟/兆)：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.programCapacity),
      callback: function($$v) {
        _vm.$set(_vm.params, "programCapacity", $$v)
      },
      expression: "params.programCapacity"
    }
  })], 1)]), _vm._v(" "), (_vm.numShow) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版数量(张/盒)：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls": false,
      "controls-position": "right",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationQuantity),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationQuantity", $$v)
      },
      expression: "params.publicationQuantity"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-formate": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.publishingTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishingTime", $$v)
      },
      expression: "params.publishingTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否书配盘标记：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.sign),
      callback: function($$v) {
        _vm.$set(_vm.params, "sign", $$v)
      },
      expression: "params.sign"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6702536d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table9.vue
// module id = 1765
// module chunks = 1